import { useCallback } from 'react';

import { BebyggelseobjektUtkast } from 'models';

import { GenreFormStriktEnum } from 'enums';

import { usePostArkivAdvancedSearchMutation } from 'api/endpoints/arkivresursSlice';

// Hook som hämtar alla arkiverade dokument utifrån genre_form_strikt. D.v.s "Ritning" eller "Fotografi"
// Då resultatet är paginerat och maxantal per sida är 100, så tar den här hooken höjd för att hämta fler om det finns.
export const useFetchAllArkivresurserByGenreFormStrikt = (
  utkast: BebyggelseobjektUtkast,
  genreFormStrikt: GenreFormStriktEnum
) => {
  const [postArkivSearch] = usePostArkivAdvancedSearchMutation();

  const fetchAllArkivresurser = useCallback(async () => {
    const allResults = [];
    let currentPage = 0;
    const pagesize = 100;

    if (utkast.publicerad_uri) {
      const pubDokumentUrl = `${new URL(utkast.publicerad_uri).origin}/dokumentation/search/advanced`;

      let totalPages = 1;

      while (currentPage < totalPages) {
        const response = await postArkivSearch({
          url: pubDokumentUrl,
          genre_form_strikt: genreFormStrikt,
          kontext_uri: utkast.publicerad_uri,
          page: currentPage,
          pagesize
        });

        if ('data' in response) {
          allResults.push(...response.data.indexResults);
          totalPages = response.data.totalPages;
          currentPage++;
        } else {
          break;
        }
      }
    }

    return allResults;
  }, [genreFormStrikt, postArkivSearch, utkast.publicerad_uri]);

  return { fetchAllArkivresurser };
};
